var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { createFilterCell } from './FilterCell';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
var settings = {
  inputComponent: function inputComponent(props) {
    return React.createElement(DatePicker, __assign({}, props));
  },
  operatorComponent: function operatorComponent(props) {
    return React.createElement(DropDownList, __assign({}, props));
  },
  emptyFilter: {
    operator: 'eq',
    value: null
  }
};
/**
 * @hidden
 */

var DateFilterCell =
/** @class */
function (_super) {
  __extends(DateFilterCell, _super);

  function DateFilterCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return DateFilterCell;
}(createFilterCell(settings));

export { DateFilterCell };